import React from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getResortUserColor } from 'src/lib/getResortUserColor';
import { resortInfoSelector } from '../../selectors/resortInfoSelector';
import { ConstructionDetailContent } from './ConstructionDetailContent';

export const ConstructionOtherDetail: React.FC = () => {
  const { id } = useParams<{ id?: string }>();
  const resortInfo = useSelector(resortInfoSelector);

  if (resortInfo?.state !== 'ok' || id === undefined) {
    return <></>;
  }
  const { profile, isFollowing } = resortInfo.result;
  const found = profile.constructions.find(item => item.resortId === id);

  if (!found) {
    return <></>;
  }

  const userColor = getResortUserColor(profile.resortPlannerPromotionColor);

  return (
    <ConstructionDetailContent
      isMyConstruction={false}
      construction={found}
      userColor={userColor}
      decoId={profile.resortPlannerPromotionDeco}
      profile={profile}
      isFollowing={isFollowing}
    />
  );
};
